import styled, { css } from "styled-components";

export const MenuContent = styled.div<{ $open?: boolean }>`
  display: grid;
  grid-template-rows: auto 1fr auto;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  z-index: 1001; /* Spor's Select uses z-index: 1000 */
  text-align: left;
  width: 367px;
  position: fixed;
  overflow: hidden;
  top: 12px;
  right: ${({ $open }) => ($open ? "12px" : "-12px")};
  bottom: 12px;
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-radius: 6px;
  transition: transform 0.3s ease-in-out;

  transform: ${({ $open }) => ($open ? "translateX(0)" : "translate(100%)")};
  color: ${({ theme }) => theme.colorTextMain};

  box-shadow: ${({ theme }) => theme.boxShadow};
`;

export const MenuButtonIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 1.6rem;
`;

export const MenuButtonLine = styled.div<{
  $open?: boolean;
  $openStyling?: string;
}>`
  width: 26px;
  height: 2px;
  background: ${({ theme }) => theme.colorTextMain};

  border-radius: 10px;
  transition: all 0.3s linear;
  position: relative;
  transform-origin: 1px;

  ${({ $open, $openStyling }) =>
    $open &&
    css`
      ${$openStyling}
    `}
`;
